import React from "react"
import { makeStyles } from '@material-ui/core/styles';
import { useStaticQuery, graphql } from "gatsby"

import mixin from '../utils/mixin'

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Slider from '@material-ui/core/Slider';
import IconButton from '@material-ui/core/IconButton';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';

import apiConfig from '../api-config'


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  mapForcast: {
    paddingBottom: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  buttonArea: {
    paddingBottom: theme.spacing(2),
  },
  player: {
    position: `relative`,
  },
  playButton: {
    position: `absolute`,
    top: `50%`,
    left: `50%`,
    WebkitTransform: `translate(-50%,-50%)`,
    transform: `translate(-50%,-50%)`,
    margin: 0,
    padding: 0,
  },
  img: {
    width: `100%`,
  },
  colorscale: {
    width: `100%`,
    height: `auto`
  }
}));

export const MapForcast = ({ data, updateParams, currentParams }) => {
  const classes = useStyles();

  const params = [...new URLSearchParams(currentParams).entries()].reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {});

  const query = useStaticQuery(graphql`
    query MapForcastQuery {
      wave_ht_colorscale: file(absolutePath: { regex: "/wave_ht_colorscale.png/" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wave_pd_colorscale: file(absolutePath: { regex: "/wave_pd_colorscale.png/" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wind_sp_colorscale: file(absolutePath: { regex: "/wind_sp_colorscale.png/" }) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  let currentType = 1;
  let colorscale = false;

  if (params.datatype === "mww30p50") {
    if (params.field === "w") {
      currentType = (params.int === "1") ? 1 : 2;
      colorscale = query?.wind_sp_colorscale?.childImageSharp?.fluid;
    }
    else if (params.field === "h") {
      currentType = (params.int === "1") ? 3 : 4;
      colorscale = query?.wave_ht_colorscale?.childImageSharp?.fluid;
    }
    else if (params.field === "p") {
      currentType = (params.int === "1") ? 5 : 6;
      colorscale = query?.wave_pd_colorscale?.childImageSharp?.fluid;
    }
  }
  else if (params.datatype === "gfs0p25") {
    currentType = (params.int === "1") ? 7 : 8;
  }

  console.log(colorscale)


  const [currentDate, setCurrentDate] = React.useState("");
  const [images, setImages] = React.useState([]);
  const [type, setType] = React.useState(currentType);

  // timer
  const [current, setCurrent] = React.useState(0);
  const refTimer = React.useRef(current)

  React.useEffect(() => {
    refTimer.current = current
  }, [current])

  const [timerId, setTimerId] = React.useState(0)


  const timer = () => {
    let n = refTimer.current + 1;
    if (n >= images.length) {
      n = 0;
    }
    setCurrentDate(images[n]["datetime"]);
    setCurrent(n);
  }

  const [pause, setPause] = React.useState(true)
  const handlePause = () => {
    clearInterval(timerId)
    setPause(true)
  }

  const [isPlayer, setIsPlayer] = React.useState(true)
  const handleResume = () => {
    setTimerId(setInterval(timer, 700))
    setPause(false)

    // 再生中はボタンを削除
    setTimeout(function() {
      setIsPlayer(false);
    }, 2000)
  }

  const handleImage = () => {
    setIsPlayer(!isPlayer);
  }
  // timer


  React.useEffect(() => {
    const loc = data.loc;
    const images = data.loc[loc.mapfield].dates.map((a, i) => {

      //const filename = `${loc.dataid}_${loc.mapfield[0]}_${loc.type}_${loc.mapid}_${a}.${loc.imgtype}`;
      //const url = `https://${loc.domain}${loc.dir}/${loc.datadate}/${filename}`;
      const fore = params.int * i
      const url = `${apiConfig.url}map.php?id=${loc.id}&token=${process.env.GATSBY_WEATHER_API_TOKEN}${currentParams}&fore=${fore}&out=img`;
      const img = new Image();
      img.src = url;
      //console.log(img.src)
      //img.onload
      return {datetime: mixin.formatDate(a), url: img.src}
    });
    setImages(images);
    setCurrentDate(images[0]["datetime"]);
  }, []);

  const handleChange = (event) => {
    currentType = event.target.value;

    let params = "";
    if (currentType === 1) {
      params = "&datatype=mww30p50&field=w&int=1"
    }
    else if (currentType === 2) {
      params = "&datatype=mww30p50&field=w&int=3"
    }
    else if (currentType === 3) {
      params = "&datatype=mww30p50&field=h&int=1"
    }
    else if (currentType === 4) {
      params = "&datatype=mww30p50&field=h&int=3"
    }
    else if (currentType === 5) {
      params = "&datatype=mww30p50&field=p&int=1"
    }
    else if (currentType === 6) {
      params = "&datatype=mww30p50&field=p&int=3"
    }
    else if (currentType === 7) {
      params = "&id=WK0001&&datatype=gfs0p25&field=w&int=3"
    }
    setType(currentType);

    updateParams(params);
  };

  const handleSlideChange = (event, newValue) => {
    setCurrentDate(images[newValue]["datetime"]);
    setCurrent(newValue);
  }


  return (
    <React.Fragment>
      <div id="map" className={classes.mapForcast}>
        <Grid container alignItems="center" justify="center">
          <Grid item xs={12} md={6}>
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label">データタイプ</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={type}
                onChange={handleChange}
              >
                <MenuItem value={1}>風 - 1時間ごと</MenuItem>
                <MenuItem value={2}>風 - 3時間ごと</MenuItem>
                <MenuItem value={3}>波高 - 1時間ごと</MenuItem>
                <MenuItem value={4}>波高 - 3時間ごと</MenuItem>
                <MenuItem value={5}>波周期 - 1時間ごと</MenuItem>
                <MenuItem value={6}>波周期 - 3時間ごと</MenuItem>
              </Select>
            </FormControl>
            { images.length > 0 &&
              <div className={classes.player}>
                <img
                  src={images[current]["url"]}
                  className={classes.img}
                  alt={images[current]["datetime"]}
                  onClick={handleImage}
                />
                { isPlayer && <div className={classes.playButton}>
                  { pause ? (
                    <IconButton size="medium" aria-label="player" onClick={handleResume}>
                      <PlayCircleOutlineIcon style={{fontSize: 64}} />
                    </IconButton>
                  ) : (
                    <IconButton size="medium" aria-label="player" onClick={handlePause}>
                      <PauseCircleOutlineIcon style={{fontSize: 64}} />
                    </IconButton>
                  )}
                </div> }
              </div>
            }
            <Typography variant="h6" component="p">
              {currentDate}
            </Typography>
            <Slider
              value={current}
              onChange={handleSlideChange}
              aria-labelledby="range-slider"
              min={0}
              max={images.length-1}
            />
            {colorscale && (
              <img
                src={colorscale?.src}
                alt={colorscale?.name || `Islands Watch colorscale`}
                className={classes.colorscale}
                imgStyle={
                  { width: 'inherit', height: 'inherit' }
                }
              />
            )}
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
}

export default MapForcast;
